//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* import CountryChart from '~/components/countryGuides/CountryChart.vue'
import CountryDescription from '~/components/countryGuides/CountryDescription.vue'
import CountryFeatures from '~/components/countryGuides/CountryFeatures.vue' */
import CountryArgentinaPaymentCard from '~/components/countryGuides/CountryArgentinaPaymentCard.vue'
/* import CountryTop from '~/components/countryGuides/CountryTop.vue' */
import FooterTop from '~/components/footer/footerTop.vue'
export default {
  components: {
    /* CountryTop, */
    CountryArgentinaPaymentCard,
    /* CountryDescription,
    CountryFeatures,
    CountryChart, */
    FooterTop
  },
  data () {
    return {
      methodList: [
        {
          color: '#1F78B4',
          title: this.$t('argentina.block3.cards'),
          percent: '45%'
        },
        {
          color: '#A6CEE3',
          title: this.$t('argentina.block3.cash'),
          percent: '25%'
        },
        {
          color: '#978ADF',
          title: this.$t('argentina.block3.bankTransfers'),
          percent: '15%'
        },
        {
          color: '#B2DF8A',
          title: this.$t('argentina.block3.digitalWallets'),
          percent: '15%'
        }
      ]
    }
  },
  head () {
    return {
      title: this.$t('footer.markets.ar').concat(' | Pagsmile '),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('seo.description')
        }
      ]
    }
  }
}
